import {
    DEFAULT_MAX_ASSIGNMENTS,
    ParkingSpot,
    ParkingWarning,
} from "../_models/ParkingSpot";

function mapWarnings(raw: any[] = []): ParkingWarning[] {
    return raw.map((w: any) => ({
        code: w?.code ?? '',
        message: w?.message ?? '',
    }));
}

export class ParkingMapper {

    static mapAllServerToLocal(serverSpots: any[] = []) {
        return serverSpots.map(ParkingMapper.mapServerToLocal);
    }

    static mapServerToLocal({
        uid,
        number,
        floor,
        loc_uid,
        holder_user_uid,
        holder_name,
        holder_email,
        holder_invitation_uid,
        holder_invitation_reused,
        assignments = [],
        max_assignments,
        notes,
        warnings,
    }: any = {}) {
        return ParkingSpot({
            uid,
            number,
            floor,
            locationUid: loc_uid,
            holderUserUid: holder_user_uid ?? null,
            holderName: holder_name ?? null,
            holderEmail: holder_email ?? null,
            holderInvitationUid: holder_invitation_uid ?? null,
            holderInvitationReused: !!holder_invitation_reused,
            assignments: assignments.map((a: any) => ({
                invitationUid: a.invitation_uid ?? null,
                email: a.email,
                userName: a.user_name ?? null,
                isSubinvitation: !!a.is_subinvitation,
                begin: a.begin ?? null,
                end: a.end ?? null,
                warnings: mapWarnings(a.warnings),
            })),
            maxAssignments: max_assignments ?? DEFAULT_MAX_ASSIGNMENTS,
            notes: notes ?? '',
            warnings: mapWarnings(warnings),
        });
    }

    static mapLocalToServer(spot: ReturnType<typeof ParkingSpot>) {
        return {
            uid: spot.uid,
            number: spot.number,
            floor: spot.floor,
            loc_uid: spot.locationUid,
            holder_user_uid: spot.holderUserUid,
            holder_invitation_uid: spot.holderInvitationUid,
            max_assignments: spot.maxAssignments,
            notes: spot.notes,
        };
    }
}
